module.exports = __webpack_public_path__ + "static/media/RESEARCH_ydwarf_radioLuminosity.cbb09340.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RESEARCH_ydwarf_radioLuminosity.jpeg
// module id = 156
// module chunks = 0